import React, { useMemo, useState } from 'react';
import {
	Card,
	IconBar,
} from '@servahealth/serva-ui-kit';
import useAuth from '../../../../Hooks/useAuth';
import DebugQuery from '../../../../Interfaces/Reports/DebugQuery';
import ReportItemNoData from '../ReportItemNoData';
import ItemIdMap from '../../../../Interfaces/Reports/ItemIdMap';

const NoDataItem = (item: ItemIdMap) => {
	const { user } = useAuth();
	const noDataParameters = item.noDataParameters;

	const debugQuery = useMemo<DebugQuery>(() => ({
		queryReportId: noDataParameters?.reportId ?? 0,
		queryReportName: noDataParameters?.reportName ?? '',
		queryReportPageId: noDataParameters?.reportPageId ?? 0,
		queryReportItemId: noDataParameters?.reportItemId ?? 0,
		queryChartId: 0,
		queryDataSetId: 0,
		queryString: '',
	}), [noDataParameters]);

	const [debugQueryVisible, setDebugQueryVisible] = useState(false);

	const iconBarArgsAdmin: any = {
		icons: [
			{
				type: 'debug',
				tooltipText: 'report debug',
				onClick: () => setDebugQueryVisible(true),
			},
		],
		orientation: 'horizontal',
		spacing: 30,
	};

	return (
		<>
			<Card
				className={'shadow-card'}
				size="small"
				title={item.noDataParameters?.reportName ?? ''}
				extra={(
					user?.runningUser.isSecurityAdmin ?
						<div><IconBar size="small" {...iconBarArgsAdmin} /></div> : 
						<div></div>
				)}
			>
				<div
					className="nodata-item"
					style={{
						height: item.fullPage ? '95%' : 'inherit',
						position: 'relative',
					}}
				>
					<ReportItemNoData
						debugQuery={debugQuery}
						debugQueryVisible={debugQueryVisible}
						hasFilters={false}
						showDebug={user?.runningUser.isSecurityAdmin}
						onCloseDebug={() => setDebugQueryVisible(false)}
					/>
				</div>
			</Card>
		</>
	);
};

export default NoDataItem;
